import { connect } from 'react-redux';
import { doInstallApp } from '../../../actions/Installation/InstallApp';
import { clearInstallMode } from '../../../actions/Installation/Installation';
import { doGenerateAppSpecificPassword, doStartAppSpecificPasswordInstallMode, setAppSpecificPasswordName as _setAppSpecificPasswordName } from '../../../actions/Installation/InstallMode/AppSpecificPassword';
import { clearInstallableAppByManualUrl as _clearInstallableAppByManualUrl, doFetchInstallableAppByManualUrl, doStartInstallableAppByManualUrlInstallMode } from '../../../actions/Installation/InstallMode/InstallableAppByManualUrl';
import { doUpgradeApp } from '../../../actions/Installation/UpgradeApp';
import InstallAppDialog from '../components/InstallAppDialog';
const mapStateToProps = state => ({
  hostPricing: state.hostPricing.hostPricing,
  installMode: state.installation.installMode,
  scopesLookup: state.scopes.scopesLookup
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  clearInstallableAppByManualUrl: () => dispatch(_clearInstallableAppByManualUrl()),
  closeInstallDialog: () => dispatch(clearInstallMode()),
  fetchInstallableAppByManualUrl: _ref => {
    let {
      context,
      installableAppByUrlId
    } = _ref;
    return dispatch(doFetchInstallableAppByManualUrl({
      context,
      installableAppByUrlId,
      mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl
    }));
  },
  generateAppSpecificPassword: _ref2 => {
    let {
      name,
      context,
      hostConfig
    } = _ref2;
    return dispatch(doGenerateAppSpecificPassword({
      name,
      context,
      hostConfig
    }));
  },
  installApp: (_ref3, featureFlags, locale) => {
    let {
      context,
      hostConfig,
      hostInfo,
      installableApp,
      installableAppId,
      relayState
    } = _ref3;
    return dispatch(doInstallApp({
      context,
      hostConfig,
      hostInfo,
      mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
      installableApp,
      installableAppId,
      relayState,
      featureFlags,
      locale
    }));
  },
  openManualUrlInstallDialog: () => dispatch(doStartInstallableAppByManualUrlInstallMode()),
  openAppSpecificPasswordDialog: _ref4 => {
    let {
      name
    } = _ref4;
    return dispatch(doStartAppSpecificPasswordInstallMode({
      name
    }));
  },
  setAppSpecificPasswordName: _ref5 => {
    let {
      name
    } = _ref5;
    return dispatch(_setAppSpecificPasswordName({
      name
    }));
  },
  upgradeApp: _ref6 => {
    let {
      context,
      hostConfig,
      installedApp,
      installableAppByKeyId,
      installableAppToUpgradeTo
    } = _ref6;
    return dispatch(doUpgradeApp({
      context,
      hostConfig,
      installedApp,
      installableAppByKeyId,
      installableAppToUpgradeTo
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(InstallAppDialog);